import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport,Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { getData } from "./data"
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as moment from "moment";

function Table(props) {
  const { data } = props
  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "pin",
      text: "PIN",
      sort: true,
      formatter: (cell, row) => <>{row?.pin ?? ""}</>,
    },
    {
      dataField: "user.phone_number",
      text: "User Name",
      sort: true,
      formatter: (cell, row) => (
        <>
          {row.channel == "Online"
            ? row?.user.phone_number
            : row?.user?.username}
        </>
      ),
    },
    {
      dataField: "channel",
      text: "Channel",
      sort: true,
      formatter: (cell, row) => <>{row?.channel ?? "Online"}</>,
    },
    {
      dataField: "betType",
      text: "Bet Type",
      sort: true,
      formatter: (cell, row) => (
        <>{row?.bets?.length == 1 ? "Single" : "Multiple"}</>
      ),
    },
    {
      dataField: "created_at",
      text: "Date Time",
      sort: true,
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      dataField: "stake",
      text: "Stake",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(parseFloat(row?.stake).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "stake_after_tax",
      text: "Stake Tax",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(
            parseFloat(row?.stake - row?.stake_after_tax).toFixed(2)
          ).toLocaleString("en-GB")}
        </>
      ),
    },
    {
      dataField: "stake_after_tax",
      text: "Actual Stake",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(parseFloat(row?.stake_after_tax).toFixed(2)).toLocaleString(
            "en-GB"
          )}
        </>
      ),
    },

    {
      dataField: "bonus_amount",
      text: "Bonus",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row?.bonus_amount ?? 0).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "wht",
      text: "WHT",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(parseFloat(row?.wht).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "to_win",
      text: "NetWin",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(parseFloat(row.to_win).toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "status",
      text: "Bet Status",
      sort: true,
      formatter: (cell, row) => (
        <>
          {row?.status == 1
            ? "won"
            : row?.status == 0
            ? "lost"
            : row?.status == 2
            ? "void"
            : "pending"}
        </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization
  const { ExportCSVButton } = CSVExport;

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data.length,
    custom: true,
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Bonus Tickets Report"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
                exportCSV={ { onlyExportFiltered: true, exportAll: false, fileName: `Bonus-Tickets-${moment(new Date()).format("DD/MM/YYYY")}.csv`}}
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <ExportCSVButton { ...toolkitProps.csvProps } className="download-table-xls-button w-md btn btn-primary">Download</ExportCSVButton>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable id="table-to-xls"
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default Table
